import { render, staticRenderFns } from "./SellerPaymentsList.vue?vue&type=template&id=7e5ac4fa"
import script from "./SellerPaymentsList.vue?vue&type=script&lang=js"
export * from "./SellerPaymentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports